//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from "swiper";
export default {
  name: "new",
  data() {
    return {
      idx: 1,
      tab_idx: 0,
      about_img: "",
      framework: "",
      html: "",
      detail: {},
      rongyu_list: [
        {
          img: require("../assets/images/rongyu1.png"),
          text: "先进施工单位",
        },
        {
          img: require("../assets/images/rongyu2.png"),
          text: "先进施工单位",
        },
        {
          img: require("../assets/images/rongyu3.png"),
          text: "先进施工单位",
        },
        {
          img: require("../assets/images/rongyu1.png"),
          text: "先进施工单位",
        },
        {
          img: require("../assets/images/rongyu2.png"),
          text: "先进施工单位",
        },
        {
          img: require("../assets/images/rongyu3.png"),
          text: "先进施工单位",
        },
      ],
      about_tab: [
        {
          text: "企业简介",
          status: 0,
        },
        {
          text: "组织架构",
          status: 1,
        },
        {
          text: "企业荣誉",
          status: 2,
        },
      ],
      banner: [
        {
          img: require("../assets/images/project_banner1.png"),
        },
        {
          img: require("../assets/images/project_banner2.png"),
        },
        {
          img: require("../assets/images/project_banner3.png"),
        },
      ],
      nav: [
        {
          text: "首页",
          status: "0",
        },
        {
          text: "关于中启",
          status: "1",
        },
        {
          text: "工程案例",
          status: "2",
        },
        {
          text: "新闻中心",
          status: "3",
        },
        {
          text: "业务中心",
          status: "4",
        },
        {
          text: "人力资源",
          status: "5",
        },
        {
          text: "联系我们",
          status: "6",
        },
      ],
    };
  },
  updated() {
    new Swiper(".swiper1", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  },
  mounted() {
    const _this = this;
    _this.details();
  },
  methods: {
    details() {
      let Base64 = require("js-base64").Base64;
      const _this = this;
      _this.$get("/header/about/fetch").then((res) => {
        console.log(res);
        _this.detail = res.data;
        _this.about_img = res.data.aboutUsVo.mainImage;
        _this.html = Base64.decode(res.data.aboutUsVo.content);
        _this.framework = Base64.decode(
          res.data.responseOriganizationVo.content
        );
      });
    },
    collect_click() {
      alert("请按住Ctrl+D收藏网站");
    },
    //导航跳转
    rout(a) {
      if (a == 0) {
        this.$router.push({
          path: "/",
        });
      } else if (a == 1) {
        this.$router.push({
          path: "/about",
        });
      } else if (a == 2) {
        this.$router.push({
          path: "/project",
        });
      } else if (a == 3) {
        this.$router.push({
          path: "/new",
        });
      } else if (a == 4) {
        this.$router.push({
          path: "/business",
        });
      } else if (a == 5) {
        this.$router.push({
          path: "/recruit",
        });
      } else if (a == 6) {
        this.$router.push({
          path: "/contact",
        });
      }
    },
    //tab点击事件
    tab_click(a) {
      const _this = this;
      _this.tab_idx = a;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/about.vue